const ClientProtectionContentSix = () => {
  const securityFeatures = [
    {
      title: "Contact Us Immediately:",
      text: "Report the incident through our official support channels or via the fraud reporting form below. We can freeze your account instantly to prevent further damage.",
    },
    {
      title: "Gather Evidence",
      text: "Try to collect emails, screenshots, transaction records, login logs and any unusual or unauthorized activity. This helps us investigate quickly and accurately.",
    },
    {
      title: "Submit a Fraud Report",
      text: "Use the dedicated form on this page to notify us of the issue.After submission, our team will investigate the incident, secure your payment, provide guidance on next steps and help you restore access safely.",
    },
  ];

  return (
    <div className="sm-security-section">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE: Main Heading */}
          <div className="col-lg-4 col-md-12 col-12">
            <div className="sm-content-left">
              <h2 className="sm-main-title">How to Report Fraud</h2>
            </div>
          </div>

          {/* RIGHT SIDE: Intro Text + Feature List */}
          <div className="col-lg-8 col-md-12 col-12">
            <div className="sm-content-right">
              <p className="sm-intro-text">
                If you suspect any fraudulent activity involving your account,
                here’s what to do:
              </p>

              <div className="sm-feature-list">
                {securityFeatures.map((item, index) => (
                  <div key={index} className="sm-feature-item">
                    <div className="sm-feature-row">
                      <div className="sm-feature-title">
                        <h3>{item.title}</h3>
                      </div>
                      <div className="sm-feature-desc">
                        <p>{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientProtectionContentSix;
